import { AddressDTO } from 'core/api';
import { deepEquals } from 'core/utils';

export function isBillingAddress(billingAddress: AddressDTO, item: AddressDTO): boolean {
	return deepEquals(billingAddress, item);
}